import { withLiveSiteStyle } from "./useLiveSiteStyle";
import { withNativeStyle } from "./useNativeStyle";
import { withWixStyle } from "./useWixStyle";
const themeStrategy = ({ useWixStyles, useNativeStyles, ...rest } = {}, isBmPlatform = false) => {
  return useNativeStyles ? withNativeStyle(rest) : useWixStyles ?? isBmPlatform ? withWixStyle(rest) : withLiveSiteStyle(rest);
};
export {
  themeStrategy
};
//# sourceMappingURL=themeStrategy.js.map
